import React from 'react';
import { twMerge } from 'tailwind-merge';

interface CardProps<T extends React.ElementType = 'div'> {
  as?: T;
  className?: string;
  children?: React.ReactNode;
}

type CardPropsWithAs<T extends React.ElementType> = CardProps<T> &
  Omit<React.ComponentPropsWithoutRef<T>, keyof CardProps>;

/**
 * Card layout component.
 *
 * @param as - The HTML element or component to render (defaults to 'div')
 * @param {...props} - The standard props accepted by `as`
 *
 * @example
 * <Card as="header" className="p-4 shadow-lg">...</Card>
 */
export const Card = <T extends React.ElementType = 'div'>({
  as,
  className,
  children,
  ...props
}: CardPropsWithAs<T>) => {
  const Component = as || 'div';

  return (
    <Component className={twMerge('rounded-lg bg-backgroundPrimary', className)} {...props}>
      {children}
    </Component>
  );
};
